import React from "react";
import {Col} from "reactstrap";
import InputField from "../../inputs/InputField.tsx";
import {ErrorMessage} from "../../../../utils/ErrorMessage.tsx";
import {Controller} from "react-hook-form";
import Select from "react-select";
import {selectInputStyle} from "../../../../utils/SelectInputStyles.ts";
import {LoyaltyGeneralDetailsContainer} from "./LoyaltyGeneralDetailsContainer.tsx";
import MandatoryField from "../../../../utils/MandatoryField.tsx";
import {useSelector} from "react-redux";
import {customNumberInputHandler} from "../../../../utils/functions/customNumberInputHandler.ts";
import {GeneralDetailsFormComponentSchema} from "../../../../pages/VLoyalty/EditCampaign/EditCampaignSchema.ts";
import {gstType} from "../Contact/FormComponentSchema.ts";

const LoyaltyParameterDetailsFormComponent: React.FC<GeneralDetailsFormComponentSchema> = ({
    register,
    errors,
    control,
    watch,
    setValue
                                                                                           }) => {

    const sessionScope = useSelector((state: any) => state.sessionData?.sessionScope);
    const decimalPoint = sessionScope?.decimalPoint || 2;

    const redemptionType:gstType [] = [
        { value: "Multiple", label: "Multiple"},
        { value: "Once", label: "Once" }
    ];

    const minDate = "2000-01-01";
    const maxDate = "2100-12-31";

    // Handle validation after input loses focus
    const handleDateBlur = (value: string) => {
        const selectedDate = watch(value);
        if (selectedDate) {
            if (selectedDate < minDate) {
                setValue && setValue(value, minDate);
            } else if (selectedDate > maxDate) {
                setValue && setValue(value, maxDate);
            }
        }
    };

    return (
        <LoyaltyGeneralDetailsContainer>
            <>
                <div className="form-container">
                    <Col md={6}>
                        <label style={{fontWeight: 600}}>Redemption Per Customer<MandatoryField/></label>
                        <Controller
                            name={"redemptionType"}
                            control={control}
                            render={({field}) => (
                                <Select
                                    placeholder={"Select Redemption type"}
                                    styles={{
                                        ...selectInputStyle,
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            height: 33.8,
                                            minHeight: 33.8,
                                            minWidth: 200,
                                            width: "100%",
                                            maxWidth: "100%",
                                            borderColor: "#e3e3e3",
                                            borderBlockWidth: "1px",
                                            borderRightWidth: "1px",
                                            borderLeftWidth: "1px",
                                            borderWidth: "0px",
                                            outlineWidth: "0px",
                                            boxShadow: "none",
                                            borderRadius: "0.2rem",
                                            fontSize: "12px",
                                            marginBottom: "10px",
                                        }),
                                    }}
                                    options={redemptionType}
                                    menuPortalTarget={document.body}
                                    {...field}
                                    onChange={(selectedOption) => {
                                        field.onChange(selectedOption);
                                    }}
                                    required
                                />
                            )}
                        />
                    </Col>
                </div>

                <div className="form-container ">
                    <Col md={3}>
                        <InputField
                            labelName="Campaign Launch Date"
                            placeholder="Launch Date"
                            name="launchDate"
                            id="launchDate"
                            inputType="date"
                            required
                            disableFutureDate={false}
                            register={register}
                            errorMessage={ErrorMessage(errors?.launchDate?.message)}
                            onBlur={() => handleDateBlur("launchDate")}
                        />
                    </Col>
                    <Col md={3}>
                        <InputField
                            labelName="Campaign Expiry Date"
                            placeholder="Expiry Date"
                            name="expiryDate"
                            id="expiryDate"
                            inputType="date"
                            disableFutureDate={false}
                            register={register}
                            onBlur={() => handleDateBlur("expiryDate")}
                        />
                    </Col>
                    <Col md={3}>
                        <InputField
                            labelName="Minimum Purchase Amount"
                            placeholder="Minimum Purchase Amount"
                            name="minPurchaseAmount"
                            id="minPurchaseAmount"
                            register={register}
                            errorMessage={ErrorMessage(errors?.minPurchaseAmount?.message)}
                            required
                            onKeyDown={customNumberInputHandler(10, decimalPoint)}
                        />
                    </Col>
                </div>
            </>
        </LoyaltyGeneralDetailsContainer>
    );
};

export default LoyaltyParameterDetailsFormComponent;
